module.exports = __webpack_public_path__ + "img/btn_send.627371d2.png";